<div class="container questionnaire-screen">
  <div class="questionnaire-card">
    <div class="questionnaire-header text-center">
      <h1>Questionário</h1>
      <p>
        As informações fornecidas neste questionário serão utilizadas para a avaliação de seu perfil de investimento, conforme regulamentação aplicável. Responda de maneira completa, precisa e atualizada para garantir uma avaliação adequada.
      </p>
    </div>

    <div class="question-container d-flex flex-column">
      <ng-container *ngFor="let question of questionnaire">
        <div class="question-group d-flex flex-column">
          <p class="question-title">{{ question.ordem }}. {{ question.pergunta }}</p>
          <div *ngFor="let option of question.alternativas" class="form-check"
            [class.form-check--selected]="answers[question.idPergunta] === option.idAlternativa">
            <app-radio [id]="'question-' + question.idPergunta + '-option-' + option.idAlternativa"
              [name]="'question-' + question.idPergunta" [value]="option.idAlternativa" [label]="option.alternativa"
              [checked]="answers[question.idPergunta] === option.idAlternativa"
              (change)="selectOption($event, question.idPergunta, option.idAlternativa)"></app-radio>
          </div>
        </div>
      </ng-container>
    </div>

    @if(allAnswered){
      <div class="sucess-container d-flex justify-content-center">
        <div class="check-icon" >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M22 11.0801V12.0001C21.9988 14.1565 21.3005 16.2548 20.0093 17.9819C18.7182 19.7091 16.9033 20.9726 14.8354 21.584C12.7674 22.1954 10.5573 22.122 8.53447 21.3747C6.51168 20.6274 4.78465 19.2462 3.61096 17.4372C2.43727 15.6281 1.87979 13.4882 2.02168 11.3364C2.16356 9.18467 2.99721 7.13643 4.39828 5.49718C5.79935 3.85793 7.69279 2.71549 9.79619 2.24025C11.8996 1.76502 14.1003 1.98245 16.07 2.86011"
              stroke="#1B894A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M22 4L12 14.01L9 11.01" stroke="#1B894A" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </div>
        <p class="text-success">
          Respostas salvas com sucesso
        </p>
      </div>
    }

    <div class="button-content justify-content-center d-flex">
      <button class="btn btn-outline-primary" (click)="goBack()">Voltar</button>
      <button class="btn btn-primary" type="button" [disabled]="!allAnswered || isSaving" (click)="goForward()">
        Seguinte
        <img src="assets/images/icons/fi_arrow-right.svg" alt="arrow-right" />
      </button>
    </div>
  </div>